<template>
    <div class="flex justify-content-between mx-5 my-3">
        <h2 class="text-secondary">Logs (gruppo {{ groupID }})</h2>
        <!-- <Button label="LOG" icon="pi pi-align-left" @click="showLogs()" class="p-button-primary w-1" /> -->
    </div>
    <div>

        <div v-if="loading" class="col-12 h-30rem flex justify-content-center align-items-center">
            <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="8" fill="transparent"
                animationDuration=".5s" aria-label="Custom ProgressSpinner" />
        </div>

        <DataTable v-if="!loading" :value="logs" paginator :rows="30" showGridlines class="file-table">
            <Column field="tabella_sorgente" header="Sorgente" >
                <template #body="slotProps" >
                    {{ eliminaUnderscore(slotProps.data.tabella_sorgente) }}
                </template>
            </Column>
            <Column field="tabella_destinazione" header="Destinatario" >
                <template #body="slotProps">
                    {{ eliminaUnderscore(slotProps.data.tabella_destinazione) }}
                </template>
            </Column>
            <Column field="table_name" header="Nome Tabella" style="width: 20%"></Column>
            <Column field="operation" header="Metodo" ></Column>
            <!-- <Column field="group_id" header="Gruppo" style="width: 5%"></Column> -->
            <Column field="total_rows" header="Record totali"></Column>
            <Column field="new_rows" header="Record nuovi"></Column>
            <Column field="appended_rows" header="Record aggiunti" ></Column>
            <Column field="updated_rows" header="Record aggiornati"></Column>
            <Column field="data_inizio" header="Data inizio"></Column>
            <Column field="data_fine" header="Data fine"></Column>
            <Column field="errore" header="Errore">
                <template #body="slotProps">
                    <button v-if="slotProps.data.errore == '1'" @click="showErrorMessage(slotProps.data.err_msg)" class="p-button p-button-rounded p-button-outlined" style="color:red;">
                        <i class="pi pi-times-circle"></i>
                    </button>
                    <i v-else class="pi pi-check-circle px-3 py-2" style="color: green;"></i>
                </template>
            </Column>
            <Column field="azioni" header="Azioni" style="min-width: 8rem">
                <template #body="slotProps">
                    <button v-if="slotProps.data.operation != 'delete' && slotProps.data.operation != 'pendV2'" @click="viewDetails(slotProps.data)" class="p-button p-button-text">
                        <i class="pi pi-eye mr-1" style="color:black"></i> Vedi dettagli
                    </button>
                </template>
            </Column>
        </DataTable>
    </div>

    <Dialog v-model:visible="error_message" modal header="Errore" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        <p class="m-0">
            {{ error_text }}
        </p>
    </Dialog>

</template>

<script>
    import { ref, computed, getCurrentInstance, onMounted } from "vue";
    import SyncService from "../../../services/ask-database-sync/database-sync";
    import router from '@/router'
    import { useRoute } from 'vue-router';
    import ProgressSpinner from 'primevue/progressspinner';

    export default {
        components: {
            ProgressSpinner
        },
        setup() {
            const logs = ref([]);
            const route = useRoute();
            const groupID = ref(route.params.group_id);
            const loading = ref(true);
            const error_message = ref(false);
            let error_text = ref('');

            const service = new SyncService();

            service.getSyncLogsByGroupId(groupID.value).then((data) => {
                logs.value = data;
                loading.value = false;
            });

            const viewDetails = (item) => {
                router.push({name: 'databaseSyncLogsDetails', params: {id: item.id}});
            };

            const eliminaUnderscore = (str) => {
                if(str) {
                    return str.replaceAll('_', ' ');
                }
            }

            const showErrorMessage = (err_msg) => {
                error_message.value = true;
                error_text.value = err_msg;
            }

            return {
                logs,
                viewDetails,
                groupID,
                loading,
                eliminaUnderscore,
                showErrorMessage,
                error_message,
                error_text
            }
        }
    }
</script>

<style scoped>
</style>